"use client";

import * as React from "react";
import { useEffect, useState } from "react";
import { Separator } from "@/components/ui/separator";
export default function ProjectOverview() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="234544" id="privacy-policy-header" className="relative flex flex-col items-center justify-center overflow-hidden bg-background pt-[160px] pb-[120px] text-center text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-multiply bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/forest_texture_overlay.png)] bg-repeat" aria-hidden="true" />

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-6">
        <h1 style={{
        transform: `translateY(${scrollY * 0.15}px)`,
        transition: "transform 0.1s ease-out"
      }} className="mb-12 font-default text-5xl font-bold leading-tight tracking-tight text-foreground md:text-[84px]">
          Datenschutzerklärung
        </h1>

        <Separator className="mb-12 h-px w-[100px] bg-primary" decorative />

        <p className="font-default text-[14px] font-semibold uppercase tracking-widest text-muted-foreground">Baumpflege Straesser&nbsp;</p>
      </div>
    </section>;
}